import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import React from 'react';

const Knowmorebtn = ({ content, link }) => {
  return (
    <Button
      component={Link}  // Use React Router's Link
      to={link}         // Provide the `to` prop for navigation
      sx={{
        backgroundColor: "rgba(243, 107, 43, 1)",
        color: "rgba(255, 255, 255, 1)",
        textDecoration: "none", // Ensure no underline
        fontFamily:"Plus Jakarta Sans",
        fontWeight:"300",
        textTransform: 'capitalize',


      }}
    >
      {content}
    </Button>
  );
};

export default Knowmorebtn;
